module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/101.9cf25190.png";